import { motion } from "framer-motion";

const ROWS = [
  { label: "Design + Build", agency: "6–8 weeks", forge: "3–5 days" },
  { label: "Copy + Content", agency: "2–4 weeks", forge: "Included · same day" },
  { label: "Motion + Interactions", agency: "$5k+ line item", forge: "Included · every tier" },
  { label: "Launch + Deploy", agency: "1–2 weeks", forge: "Same day" },
  { label: "Editing Guide", agency: "Not offered", forge: "Included, plain English" },
  { label: "First Edit Round", agency: "$1k–$3k billable", forge: "Included, free" },
  { label: "Total lead time", agency: "6–12 weeks", forge: "Under 2 weeks" },
];

export default function WebsiteCheatsheet() {
  return (
    <section
      data-testid="website-cheatsheet"
      className="max-w-[1100px] mx-auto px-6 sm:px-10 pb-16"
    >
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-100px" }}
        transition={{ duration: 0.7 }}
        className="border border-[#27272a] bg-[#0b0b0d]/70"
      >
        <div className="px-6 sm:px-10 py-6 border-b border-[#27272a]">
          <p className="font-mono text-[10px] uppercase tracking-[0.42em] text-[#ff5a00]">
            Cost + Time · One-page cheatsheet
          </p>
          <h3 className="font-display text-3xl sm:text-4xl text-[#ededed] mt-3">
            Agency vs. The Forge
          </h3>
        </div>

        <div className="hidden md:grid grid-cols-3 px-6 sm:px-10 py-3 border-b border-[#27272a] font-mono text-[10px] uppercase tracking-[0.32em] text-[#52525b]">
          <span>Line item</span>
          <span>Traditional agency</span>
          <span className="text-[#ff5a00]">Resilience · The Forge</span>
        </div>

        <div>
          {ROWS.map((r, i) => (
            <div
              key={r.label}
              data-testid={`cheatsheet-row-${i}`}
              className="grid grid-cols-1 md:grid-cols-3 gap-y-1 gap-x-4 px-6 sm:px-10 py-4 border-b border-white/5 last:border-0 hover:bg-[#141417]/60 transition-colors"
            >
              <p className="font-display text-lg text-[#ededed]">{r.label}</p>
              <p className="font-body text-sm text-[#a1a1aa] line-through decoration-[#52525b]/60">
                {r.agency}
              </p>
              <p className="font-body text-sm text-[#ff5a00]">{r.forge}</p>
            </div>
          ))}
        </div>

        <div className="px-6 sm:px-10 py-6 border-t border-[#27272a]">
          <p className="font-mono text-[10px] uppercase tracking-[0.32em] text-[#52525b]">
            Print, save, or share this page — everything above is on the record.
          </p>
        </div>
      </motion.div>
    </section>
  );
}
